import type { SVGProps } from "react";
export const Mail = (props: SVGProps<SVGSVGElement>) => (
	<svg
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		aria-hidden={true}
		{...props}
	>
		<path
			d="M2.5 19.5V4.5H21.5V19.5H2.5ZM12 12.5577L4 7.44225V18H20V7.44225L12 12.5577ZM12 11L19.8463 6H4.15375L12 11ZM4 7.44225V6V18V7.44225Z"
			fill="currentColor"
		/>
	</svg>
);
